<div class="custom-snackbar-container {{class}}">
    <div class="custom-snackbar-content" [innerHTML]="sanitizedHtml"></div>
    <button mat-button class="custom-snackbar-close" (click)="close()" type="button"
            [attr.aria-label]="closeButtonLabel">
        {{ closeButtonLabel }}
    </button>
</div>
